<template>
  <v-app>
    <v-container fluid fill-height>
      <v-row
        justify="center"
        align="center"
        style="background: #eee"
        class="pa-0 mt-0"
      >
        <v-col
          cols="12"
          md="12"
          lg="12"
          style="background: #eee"
          class="pt-0 pa-0"
        >
          <v-row
            style="background-color: rgb(139 139 139 / 15%)"
            class="pa-4 ml-0 mr-0"
            ><v-col cols="12" sm="1" style="margin-right: -14px" class="pa-0"
              ><v-img src="/img/acara_logo_2.png" width="80"
            /></v-col>
            <v-col
              cols="12"
              sm="11"
              style="margin-right: -14px"
              class="pa-3 pt-5 ml-4"
              ><h1 style="font-size: 32px; font-weight: bold">
                Solicitud de Acceso al Portal para Nuevos Concesionarios
              </h1></v-col
            ></v-row
          ></v-col
        >
        <v-col
          cols="12"
          md="12"
          lg="10"
          style="background: #eee"
          class="mt-4 pa-0"
        >
          <v-card
            class="pa-0 pl-3 pr-3 elevation-0 mt-0"
            style="background: #eee"
          >
            <v-form ref="solicitudUsuarioForm" v-model="valid" lazy-validation>
              <v-toolbar dark color="primary" class="mt-4">
                <v-toolbar-title>Datos del Concesionario</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text class="elevation-1" style="background: #fff">
                <v-row class="pt-2">
                  <v-col cols="12" md="1" sm="12" class="pa-0 ml-6">
                    <v-img class="icon-size" :src="avatar"></v-img>
                  </v-col>
                  <v-col cols="12" md="4" sm="12" class="pa-0 pl-4 pt-4">
                    <v-text-field
                      v-model="editedItem.cuitcuil"
                      label="CUIT/CUIL"
                      hint="Ingrese solo números"
                      maxLength="13"
                      class="input-h1"
                      v-mask="'##-########-#'"
                      prepend-inner-icon="mdi-card-account-details"
                      :rules="[$rulesRequerido, ruleUniqueCuit]"
                      :error-messages="customErrorMessage"
                      @input="updateUserName"
                      ref="cuitField"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" class="pa-0 pl-4 pt-4">
                    <v-text-field
                      v-model="editedItem.razon_social"
                      label="Razón Social"
                      class="input-h1"
                      prepend-inner-icon="mdi-card-account-details"
                      :rules="[$rulesRequerido]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" sm="12" class="pa-0 pl-4"></v-col>
                </v-row>
                <v-row class="pb-3">
                  <v-col cols="12" md="9" sm="12" class="py-0">
                    <v-toolbar dark color="primary" class="mt-4">
                      <v-toolbar-title>Dirección</v-toolbar-title>
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        color="white"
                        outlined
                        x-small
                        title="Del punto de entrega pedidos"
                      >
                        <v-icon
                          title="Del punto de entrega pedidos"
                          class="mx-2"
                          fab
                          dark
                          color="white"
                          outlined
                          small
                        >
                          mdi-help
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card-text
                      class="elevation-1 pb-2"
                      style="background: #fff"
                    >
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-autocomplete
                                :items="provincias"
                                item-value="id"
                                item-text="nombre"
                                label="Provincia"
                                v-model="editedItem.datos_entidad.provincia"
                                :rules="[$rulesRequerido]"
                                @change="
                                  getPartidos(
                                    editedItem.datos_entidad.provincia.id
                                  )
                                "
                                return-object
                              ></v-autocomplete
                            ></v-col>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-autocomplete
                                :items="partidos"
                                item-value="id"
                                item-text="nombre"
                                label="Partido"
                                v-model="editedItem.datos_entidad.partido"
                                :rules="[$rulesRequerido]"
                                @change="
                                  getCiudades(
                                    editedItem.datos_entidad.partido.id
                                  )
                                "
                                return-object
                              ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-autocomplete
                                :items="ciudades"
                                item-value="id"
                                item-text="nombre"
                                label="Localidad"
                                v-model="editedItem.datos_entidad.ciudad"
                                :rules="[$rulesRequerido]"
                                return-object
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="8" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.calle"
                                label="Calle"
                                :rules="[$rulesRequerido, $rulesMax50]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.numero"
                                label="Numero"
                                :rules="[
                                  $rulesRequerido,
                                  $rulesEnterosPositivos,
                                  $rulesMax6,
                                ]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.piso"
                                label="Piso"
                                :rules="[$rulesEnterosPositivos, $rulesMax6]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.depto"
                                label="Depto"
                                :rules="[$rulesMax6]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.cp"
                                label="Código Postal"
                                :rules="[
                                  $rulesEnterosPositivos,
                                  $rulesNumericoMax10,
                                  $rulesRequerido,
                                ]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" md="3" sm="12" class="py-0">
                    <v-toolbar dark color="primary" class="mt-4 elevation-1">
                      <v-toolbar-title>Contacto</v-toolbar-title>
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        color="white"
                        outlined
                        x-small
                        title="Del punto de entrega pedidos"
                      >
                        <v-icon title="Del punto de entrega" small dark>
                          mdi-help
                        </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card-text
                      class="elevation-1 pb-2"
                      style="background: #fff"
                    >
                      <v-row>
                        <v-col>
                          <v-row>
                            <v-col cols="12" md="12" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.telefono"
                                label="Telefono"
                                :rules="[$rulesRequerido, $rulesTelefono]"
                                maxlength="20"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.celular"
                                label="Celular"
                                :rules="[$rulesRequerido, $rulesTelefono]"
                                maxlength="20"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" sm="12" class="py-0">
                              <v-text-field
                                v-model="editedItem.datos_entidad.mail"
                                label="Email"
                                :rules="[$rulesRequerido, $rulesMail]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-toolbar dark color="primary" class="mt-4">
                <v-toolbar-title>Datos Del Usuario</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text class="elevation-1" style="background: #fff">
                <v-row
                  :style="{
                    borderRadius: '10px',
                    margin: '4px',
                  }"
                >
                  <v-col>
                    <v-row>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.apellido"
                          label="Apellido"
                          :rules="[$rulesRequerido, $rulesAlfaNum, $rulesMax50]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.nombre"
                          label="Nombre"
                          :rules="[$rulesRequerido, $rulesAlfaNum, $rulesMax50]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-autocomplete
                          v-model="editedItem.datos_usuario.tipo_documento"
                          :items="identifiertypes"
                          item-text="name"
                          item-value="id"
                          label="Tipo Documento"
                          return-object
                          :rules="[$rulesRequerido]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.documento"
                          label="Documento"
                          class="input-h1"
                          :rules="[$rulesRequerido, $rulesAlfaNum]"
                          maxlength="9"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.usuario"
                          label="Nombre de usuario"
                          :rules="[$rulesRequerido]"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.telefono"
                          label="Telefono"
                          :rules="[$rulesRequerido, $rulesTelefono]"
                          maxlength="20"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.celular"
                          label="Celular"
                          :rules="[$rulesRequerido, $rulesTelefono]"
                          maxlength="20"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="py-0">
                        <v-text-field
                          v-model="editedItem.datos_usuario.mail"
                          label="Correo"
                          :rules="[
                            $rulesRequerido,
                            $rulesMail,
                            ruleUniqueEmail,
                          ]"
                          :error-messages="customErrorEmailMessage"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <template>
                  <v-row>
                    <v-col cols="12" sm="12" class="pa-0 pl-4 pr-4">
                      <v-divider
                        class="mt-2 pa-2"
                        :class="
                          Number(editedItem.index) % 2 == 0
                            ? 'border-primary'
                            : 'border-primary-2'
                        "
                      ></v-divider>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
              <br />
              <v-row>
                <v-col cols="12" md="12">
                  <v-alert
                    title="Alert title"
                    text=""
                    type="info"
                    border="left"
                    variant="tonal"
                    prominent
                  >
                    <p>
                      Una vez finalizada la solicitud, la misma estará pendiente
                      de aprobación por parte de
                      <b style="font-weight: bold">ACARA</b>. Toda la
                      información relevante se enviará a la dirección de correo
                      electrónico proporcionada en el formulario. <br />
                      Si tiene algún inconveniente no dude en contactarse al
                      <b style="font-weight: bold">(011) 5236-6500</b> o vía
                      mail a
                      <b style="font-weight: bold">formularios@acara.org.ar</b>.
                    </p></v-alert
                  ></v-col
                ></v-row
              >
              <v-card-actions>
                <v-row>
                  <v-col class="text-right" cols="12" md="12" sm="12">
                    <v-btn color="red" @click="exit()">Cancelar</v-btn>
                    <v-btn color="orange" @click="reset()">Limpiar</v-btn>
                    <v-btn color="primary" :disabled="!valid" @click="save()"
                      >Enviar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>

            <v-snackbar
              v-model="snackbar"
              :bottom="true"
              :color="color"
              :timeout="timeout"
            >
              <div v-html="text"></div>

              <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="snackbar = false">
                  Cerrar
                </v-btn>
              </template>
            </v-snackbar>
            <vue-confirm-dialog></vue-confirm-dialog>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <section
      class="contacto"
      style="padding: 12px 0 12px 0; background-color: #0177bd; color: #fff"
      fluid fill-height
    >

      <v-row
        justify="center"
        align="center"
        class="pa-0 mt-0"

         >
          <v-col md="3" xs="12">
            <v-row>
              <v-col md="2"
                ><img data-v-3bae8626="" src="data:image/png;base64,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" alt="Contactate con nosotros" class="icon-size-2"></v-col>
              <v-col md="10">
                <p>Contactate con nosotros<br />(011) 5236 6500</p></v-col
              >
            </v-row>
          </v-col>
          <v-col md="3" xs="12">
            <v-row>
              <v-col md="2"
                ><img data-v-3bae8626="" src="data:image/png;base64,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" alt="Envianos tus consultas a" class="icon-size-2"></v-col>
              <v-col md="10">
                <p>
                  Envianos tus consultas a <br /><a
                    href="mailto:formularios@acara.org.ar"
                    style="color: #fff"
                    >formularios@acara.org.ar</a
                  >
                </p></v-col
              >
            </v-row>
          </v-col>
          <v-col md="3" xs="12">
            <v-row>
              <v-col md="2"
                ><img data-v-3bae8626="" src="data:image/png;base64,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" alt="Encontranos" class="icon-size-2"></v-col>
              <v-col md="10"
                ><p>Encontranos<br />estés dónde estés</p></v-col
              >
            </v-row>
          </v-col>
      </v-row>

    </section>
    <footer>
      <div
        class="terminos"
        style="
          padding: 12px 0 12px 0;
          background-color: #011f5b;
          color: #6db2d9;
        "
      >
        <div class="">
          <div class="row ml-4" >
            <div class="col-6 text-left ml-2">
              <p style="margin-bottom: 5px">Av Córdoba 3371, CABA</p>
              <p>2024 ACARA - Todos los derechos reservados.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </v-app>
</template>

<script>
function getTitle() {
  return "solicitud usuario";
}

export default {
  data: (vm) => ({
    valid: true,
    route: "solicitudUsuario",
    dialog: false,
    snackbar: false,
    visible: true,
    text: "Registro Insertado",
    color: "success",
    timeout: 4000,
    editedIndex: -1,
    editedItem: {
      cuit: "",
      razon_social: "",
      estado_id: 1,
      datos_entidad: {},
      datos_usuario: {},
    },
    defaultItem: {
      cuit: "",
      razon_social: "",
      estado_id: 1,
      datos_entidad: {},
      datos_usuario: {},
    },
    provincias: [],
    partidos: [],
    ciudades: [],

    identifiertypes: [],
    paises: [],
    avatar: "/img/user_primary.png",
    formPerson: {},
    routeBussinesPartnersIsClient: "bussinessPartnerIsClient",

    cuitUnique: true,
    keyCuit: 0,
    customErrorMessage: "", // Mensaje de error personalizado
    customErrorEmailMessage: "", // Mensaje de error personalizado
  }),

  computed: {},

  created() {
    this.$cv("colorPrimary");
    this.$getData(["identifiertypes" /*, "paises"*/, "provincias"]);
    //this.setDatosPrueba();
  },

  methods: {
    updateUserName() {
      let cuitcuil = this.editedItem.cuitcuil;
      this.editedItem.datos_usuario.usuario = "C" + cuitcuil.replace(/-/g, "");
      /*this.editedItem.datos_usuario.usuario = this.editedItem.cuit
        ? `${this.editedItem.datos_usuario.usuario.toLowerCase()}@example.com`
        : "";*/
    },

    /*async isClient(value) {
      try {
        if (value) {
          if (value.length == 13) {
            let cuit = value.replace(/-/g, "");
            cuit = "C" + cuit;
            let params = cuit + "/TST_MJV20";

            const response = await this.$axiosApi.getByCriteria(
              this.routeBussinesPartnersIsClient,
              params
            );

            return response.data.data.isClient;
          } else {
            return 0;
          }
        }
      } catch (error) {
        Swal.close();
        return error.response.status;
      }
    },*/

    async ruleUniqueCuit(value) {
      if (typeof value !== "undefined" && value != null && value !== "") {
        this.customErrorMessage = "";
        //let resp = await this.$isClient(value, 'A80', process.env.VUE_APP_DB_MJ);
        let resp = await this.$isClient(value, 'C', process.env.VUE_APP_DB_ACARA);
        switch (resp) {
          case 1:
            this.customErrorMessage = "Este CUIT ya está en uso";
            this.editedItem.datos_usuario.usuario = "";
            return false;

          case -1:
            this.customErrorMessage = "CUIT inválido";
            this.editedItem.datos_usuario.usuario = "";
            return false;

          default:
            this.customErrorMessage = "";
            return true;
        }
        /*
        if (resp == 1) {
          this.customErrorMessage = "Este CUIT ya está en uso";
          this.editedItem.datos_usuario.usuario = "";
          return false;
        } else {
          this.customErrorMessage = "";
          return true;
        }
        */
      } else {
        this.customErrorMessage = "";
         return true;
      }
    },
    async ruleUniqueEmail(value) {
      if (typeof value !== "undefined" && value != null && value !== "") {
        this.customErrorMessage = "";
        let resp = await this.$isUser(value);

        if (resp === true) {
          this.customErrorEmailMessage =
            "El email ingresado ya está registrado. Por favor, ingrese un email diferente";
          //this.editedItem.datos_usuario.usuario = "";
          return false;
        } else {
          this.customErrorEmailMessage = "";
          return true;
        }
      } else {
        this.customErrorMessage = "";
         return true;
      }
    },
    setDatosPrueba() {
      //this.editedItem.cuitcuil = "";
      this.editedItem.razon_social = "AUTOFRANCE PEUGEOT";
      this.editedItem.datos_entidad.telefono = "1111111111";
      this.editedItem.datos_entidad.celular = "1556443322";
      this.editedItem.datos_entidad.mail = "mail@mail.com";
      this.editedItem.datos_entidad.pais = { code: "ARG", name: "ARGENTINA" };
      this.editedItem.datos_entidad.provincia = {
        id: "06",
        name: "Buenos Aires",
      };
      this.editedItem.datos_entidad.localidad = "MONTE GRANDE";
      this.editedItem.datos_entidad.cp = "1803";
      this.editedItem.datos_entidad.calle = "ALEM";
      this.editedItem.datos_entidad.numero = "100";
      this.editedItem.datos_usuario.apellido = "APELLIDO PERSONA";
      this.editedItem.datos_usuario.nombre = "NOMBRE PERSONA";
      this.editedItem.datos_usuario.tipo_documento = { id: 4, name: "DNI" };
      this.editedItem.datos_usuario.documento = "30987222";
      this.editedItem.datos_usuario.usuario = "";
      this.editedItem.datos_usuario.telefono = "2051882299";
      this.editedItem.datos_usuario.celular = "1122334455";
      this.editedItem.datos_usuario.mail = "luis.quintero1983@gmail.com";
    },

    reset() {
      //this.$refs.solicitudUsuarioForm.reset();
      //this.editedItem = Object.assign({}, this.defaultItem);
      this.$refs.solicitudUsuarioForm.resetValidation();
      this.$refs.solicitudUsuarioForm.reset();
      this.editedItem = Object.assign({}, this.defaultItem);

      /*this.$nextTick(() => {
																																				console.log(this.editedItem);
																																				this.editedItem = Object.assign({}, this.defaultItem);

																																				this.editedIndex = -1;
																																			});*/

      console.log(this.editedItem);
      //this.resetValidation();
    },
    resetValidation() {
      this.$refs.solicitudUsuarioForm.resetValidation();
    },

    save() {

      if (this.$refs.solicitudUsuarioForm.validate()) {
        this.editedItem.cuit = this.editedItem.cuitcuil.replace(/-/g, "");
        let tituloSwal = "Confirmación";
        let tituloSwalOk = "registraron";
        Swal.fire({
          title: "<b>" + tituloSwal + "?</b>",
          text: "Usted está por enviar una solicitud a ACARA para la creación de un usuario Concesionario",
          icon: "question",
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: true,
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.alertGetInfo("Enviando solicitud de usuario");
            this.$axiosApi
              .post(this.route, this.editedItem)
              .then((r) => {
                //console.log(this.editedItem);
                if (
                  typeof r !== "undefined" &&
                  r !== null &&
                  (r.status == 200 || r.status == 201 || r.succeeded == true)
                ) {
                  Swal.close();
                  Swal.fire({
                    title: "Se " + tituloSwalOk + " los datos de la solicitud ",
                    icon: "success",
                    html: "Su solicitud se encuentra en proceso de evaluación",
                    showCloseButton: false,
                    showCancelButton: false,
                    focusConfirm: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = "/";
                      return;

                      //this.$router.push({ path: "/" });
                    }
                  });
                } else {
                  Swal.close();
                  Swal.fire({
                    icon: "error",
                    title: "Solicitud de Usuario",
                    text: "Ha ocurrido un error al intentar registrar los datos de la solicitud",
                  });
                }

                return;
              })
              .catch((e) => {
                Swal.close();
                console.log(e);
                this.snackbar = true;
                this.text = "Error al ingresar los datos. Error: " + e.message;
                this.color = "error";
              });

            //this.$alertGetInfo("Registrando información del tramite");
          }
        });
      }
    },

    async getPartidos(provincia_id) {
      Swal.alertGetInfo("Obteniendo Partidos <br><b></b>");
      this.partidos = [];
      let url = "api/provincias/public/" + provincia_id + "/partidos";

      this.$axiosApi
        .sendRequest(url, "get")
        .then((r) => {
          if (r.data.data) {

            this.partidos = r.data.data;
            Swal.close();
          }
        })
        .catch(function (error) {
          Swal.close();
          console.log(error);
        });
    },
    async getCiudades(partido_id) {
      Swal.alertGetInfo("Obteniendo Ciudades <br><b></b>");
      this.ciudades = [];
      let url = "api/partidos/public/" + partido_id + "/localidades";

      this.$axiosApi
        .sendRequest(url, "get")
        .then((r) => {
          if (r.data.data) {
             this.ciudades = r.data.data;
            Swal.close();
          }
        })
        .catch(function (error) {
          Swal.close();
          console.log(error);
        });
    },
    exit() {
      window.location.href =
        window.location.protocol + "//" + window.location.host;
    },
  },
  mounted() {
    console.log("Componente " + getTitle() + " creado");
  },
};
</script>
<style>
.container {
  margin-left: 0px;
  padding: 0px;
  max-width: 100% !important;
}
.icon-size {
  width: 80px !important;
  height: 80px !important;
}
.icon-size-2 {
  width: 40px !important;
  height: 40px !important;
}
.bg-gris {
  background-color: #eee;
}
</style>
